import IconChevron from '$partials/icons/icon-chevron';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/offices').OfficeListing}
 */
const OfficeListing = ({ markets }) => {
    if (markets?.length <= 0) {
        return null;
    }
    return (
        <>
            <div className='layout-container layout-site-outer-padding pt-24 pb-32 sm:py-40 md:py-48'>
                <div className='sm:-mx-16 md:-mx-24'>
                    <section className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-y-40'>
                        {markets.map((market, i) => {
                            return (
                                <ul
                                    className={`sm:px-16 md:px-24 sm:border-l sm:border-l-tint-dark ${i % 4 === 0 ? 'md:border-opacity-0' : 'md:border-opacity-20'} ${i % 2 === 0 ? 'sm:border-opacity-0' : 'sm:border-opacity-20'}`}
                                    key={market.id}>
                                    <span className='type-style-3 mb-32 block'>
                                        {market.title}
                                    </span>
                                    {market?.officeDetailPages?.edges?.length > 0 && (
                                        <>
                                            {market?.officeDetailPages.edges.map((p) => {
                                                return (
                                                    <li
                                                        className='border-t border-main-border py-16'
                                                        key={p.node.id}>
                                                        <a
                                                            className='type-style-eyebrow inline-flex w-full items-center justify-between'
                                                            href={p.node.url}>
                                                            <span>
                                                                {p.node.title}
                                                            </span>
                                                            <span>
                                                                <IconChevron className='ml-10 -rotate-90' />
                                                            </span>
                                                        </a>
                                                    </li>
                                                );
                                            })}
                                        </>
                                    )}
                                </ul>
                            );
                        })}
                    </section>
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default OfficeListing;
